var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import axios from 'axios';
import { getCareAgentInfo, injectStorageEvent, saveUserInfo, } from './global.functions';
import { CACHE_EVENTS_AUTO_LOGOUT, ERROR_STATUS, SESSION_EXPIRED_MESSAGE, } from './global.constants';
import { logoutCache } from '../pages/WCPages/Login/Login.action';
import { PUBLIC_APIS } from './apiEndPoints';
var CARE_PORTAL_URL = "".concat((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin, "/api/");
var isAlreadyFetchingAccessToken = false;
var subscribers = [];
// --- Manage cancelable requests ---
var pendingControllers = [];
function cancelAllPendingRequests() {
    pendingControllers.forEach(function (ctrl) { return ctrl.abort(); });
    pendingControllers.length = 0;
}
function createCancelableController() {
    var controller = new AbortController();
    pendingControllers.push(controller);
    return controller;
}
// --- Subscriber logic ---
function onAccessTokenFetched(access_token) {
    subscribers.forEach(function (callback) { return callback(access_token); });
    subscribers = [];
}
function addSubscriber(callback) {
    subscribers.push(callback);
}
function retryRequest(originalRequest) {
    return new Promise(function (resolve) {
        addSubscriber(function (access_token) {
            originalRequest.headers.Authorization = "Bearer ".concat(access_token);
            resolve(axios(originalRequest));
        });
    });
}
/**
 * @description
 * Attempts to fetch a new access token using the stored refresh token.
 * If successful:
 *   - Saves the new access and refresh tokens in local storage
 *   - Notifies all pending requests to retry with the updated token
 * If unsuccessful:
 *   - Dispatches logout and session expiration events (only on 403 from refresh API)
 *
 * @param store - Redux store instance used to dispatch logout action
 * @returns Promise<boolean> - Returns true if token refresh is successful, otherwise false/rejects
 */
var updateAuthToken = function (store) { return __awaiter(void 0, void 0, Promise, function () {
    var user, userObject, refreshToken, sessionId, res, resp, careAgentDetails, loginUserDetails, err_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                user = localStorage.getItem('userInfo');
                userObject = user ? JSON.parse(user) : null;
                refreshToken = userObject === null || userObject === void 0 ? void 0 : userObject.refreshToken;
                sessionId = userObject.sessionId;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.post("".concat(CARE_PORTAL_URL, "cognito/authentication/access-token"), {
                        email: userObject === null || userObject === void 0 ? void 0 : userObject.email,
                        refresh_token: refreshToken,
                        session_id: sessionId,
                    })];
            case 2:
                res = _b.sent();
                resp = res.data;
                if (resp.application_code === 200) {
                    careAgentDetails = getCareAgentInfo();
                    loginUserDetails = __assign(__assign({}, careAgentDetails), { email: userObject === null || userObject === void 0 ? void 0 : userObject.email, accessToken: resp.data[0].jwt, refreshToken: resp.data[0].refresh_token });
                    saveUserInfo(loginUserDetails);
                    isAlreadyFetchingAccessToken = false;
                    // notify all pending requests
                    onAccessTokenFetched(loginUserDetails.accessToken);
                    return [2 /*return*/, true];
                }
                throw new Error('Invalid application_code response');
            case 3:
                err_1 = _b.sent();
                isAlreadyFetchingAccessToken = false;
                // ❌ refresh token invalid → logout
                if (((_a = err_1.response) === null || _a === void 0 ? void 0 : _a.status) === 403) {
                    injectStorageEvent(CACHE_EVENTS_AUTO_LOGOUT.SESSION_FLUSH, ERROR_STATUS.UNAUTHORIZED);
                    store.dispatch(logoutCache(SESSION_EXPIRED_MESSAGE, 'error'));
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, Promise.reject(err_1)];
            case 4: return [2 /*return*/];
        }
    });
}); };
// Interceptors let you handle requests before they are processed and responses before they reach then/catch.
// Adding interceptors for request and response handling.
/**
 * @description Axios interceptor to modify API calls.
 * - Attaches access token to authorized requests
 * - Handles 401 by triggering token refresh and retrying the original request
 * - Handles 403 from refresh API by logging out the user
 * - 403 from other APIs is handled separately via RBAC (unauthorized access)
 *
 * @param store redux store
 */
var interceptor = function (store) {
    // REQUEST INTERCEPTOR
    axios.interceptors.request.use(function (config) {
        var user = localStorage.getItem('userInfo');
        var userObject = user ? JSON.parse(user) : null;
        var isPublicApi = Object.values(PUBLIC_APIS).some(function (endPoint) { var _a; return config.url === "".concat((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin, "/api/").concat(endPoint); });
        // cancel unauthenticated requests
        if (!userObject && !isPublicApi) {
            cancelAllPendingRequests();
            var controller = createCancelableController();
            config.signal = controller.signal;
        }
        // attach token
        if (userObject === null || userObject === void 0 ? void 0 : userObject.accessToken) {
            config.headers.Authorization = "Bearer ".concat(userObject.accessToken);
        }
        return config;
    });
    // RESPONSE INTERCEPTOR
    axios.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var user, userObject, originalRequest, refreshToken, isSuccess, updatedUser, err_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    user = localStorage.getItem('userInfo');
                    userObject = user ? JSON.parse(user) : null;
                    originalRequest = error.config;
                    refreshToken = userObject === null || userObject === void 0 ? void 0 : userObject.refreshToken;
                    if (!(refreshToken &&
                        ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 &&
                        !originalRequest._retry)) return [3 /*break*/, 6];
                    originalRequest._retry = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    if (!!isAlreadyFetchingAccessToken) return [3 /*break*/, 3];
                    isAlreadyFetchingAccessToken = true;
                    return [4 /*yield*/, updateAuthToken(store)];
                case 2:
                    isSuccess = _b.sent();
                    // ❌ refresh failed → stop retry
                    if (!isSuccess) {
                        return [2 /*return*/, Promise.reject(__assign(__assign({}, error), { skipErrorHandler: true }))];
                    }
                    updatedUser = JSON.parse(localStorage.getItem('userInfo') || '{}');
                    originalRequest.headers.Authorization = "Bearer ".concat(updatedUser.accessToken);
                    return [2 /*return*/, axios(originalRequest)];
                case 3: 
                // ⏳ wait for token
                return [2 /*return*/, retryRequest(originalRequest)];
                case 4: return [3 /*break*/, 6];
                case 5:
                    err_2 = _b.sent();
                    return [2 /*return*/, Promise.reject(err_2)];
                case 6: return [2 /*return*/, Promise.reject(error)];
            }
        });
    }); });
};
export default interceptor;
